import { Component, Input } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';

/**
 * Import Pages
 */
import { HomePage } from '../../pages/home/home';

import {Contacts, ContactFieldType, ContactFindOptions} from 'ionic-native';
import { Task } from '../../providers/task';
import { User } from '../../providers/user';
import * as Clipboard from 'clipboard/dist/clipboard.min.js';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Component({
  selector: 'tasks-detail',
  templateUrl: 'tasks-detail.html'
})

export class TasksDetailComponent {
  photo64: string;

  @Input() entry: any = {
    id: '',
    title: '',
    time: '', // h:m
    amount: '',
    transfer: 'false',
    nights:'',
    modifiedAt: '',
    image:'',
    tinyurl:'',
    link: '', 
    owner: '',
    active: false,
    likes: [],
    comments: []
    //days: [true, false, false, false, false, false, false] // days of week
  };
  submitted: boolean = false;
  dayInvalid: boolean = false;

  constructor(
    public nav: NavController,
    public navParams: NavParams,
    public task: Task,
    public user: User,
    public http: Http,
    public alert: AlertController
  ) {
    
    var clipboard = new Clipboard('#cpyBtn');
    
    clipboard.on('success', function(e) {
        console.info('Action:', e.action);
        console.info('Text:', e.text);
        console.info('Trigger:', e.trigger);
        e.clearSelection();
    });

    clipboard.on('error', function(e) {
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
    });
    this.entry.modifiedAt = this.today();

    if (this.navParams.data.id) {
      this.entry = this.navParams.data;
    } else {
      // current day of week
      //var d = new Date();
      // set current time
      this.entry.time = this.today();  //this.addZero(d.getHours()) + ':' + this.addZero(d.getMinutes());
    }
  }

  getAirbnbPic(object:any, entry:any)
  {

    var uri = entry.link;
    var urlexp = new RegExp( '(http|ftp|https)://[\\w-]+(\\.[\\w-]+)+([\\w-.,@?^=%&:/~+#-]*[\\w@?^=%&;/~+#-])?' );
    var match = urlexp.test(uri);
    if(uri && match)
    {
      var data = "";
      if(uri.includes("?"))
         data = uri.substring(0, uri.indexOf("?"));
      else
          data = uri;

      console.info("los gehts " + encodeURI(data));
      this.http.get('https://opengraph.io/api/1.0/site/'+ encodeURI(data) +'?app_id=592e7fc3905caa3b25309b4e').map(res => res.json()).subscribe(data => {
          debugger;
          console.info(JSON.stringify(data));
          var image = JSON.parse(JSON.stringify(data)).openGraph.image;
          var title = JSON.parse(JSON.stringify(data)).openGraph.title;
          console.info(image);
          this.entry.image = image;
          this.entry.title = title;
          this.task
          .save(this.entry)
          .then(() => {
            console.info(`task ${this.entry.title} saved with key` + this.entry.id);
          }).catch((e) => { console.error(e); });
      });
    }
  }

  taskUpdate(form) {
    this.submitted = true;
    this.entry.owner = this.user.profile().uid;
    if (form.valid && !this.dayInvalid) {
      this.task
        .save(this.entry)
        .then(() => {
          console.info(`task ${this.entry.title} saved`);
          this.nav.pop(); //back to listing
        }).catch((e) => { console.error(e); });
    }
  }


  /**
   * Day Change
   * 
   * Looks for inexistent days
   * 
   * @returns {boolean}
   * 
   * @memberOf TasksDetailComponent
   
  dayChange(): boolean {
    if (this.entry.days.length)
      return this.dayInvalid = !this.entry.days.filter((item) => {
        return item;
      }).length;
  }
  */

  today() : String{
    return new Date().toISOString();
  }

  nextYear() : String{
    return new Date().toISOString();
  }

  addZero(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }


  remove(task) {
    let confirm = this.alert.create({
      title: task.title,
      message: 'Sicher das wir den Gutschein löschen sollen? Dies kann nicht Rückgängig gemacht werden.',
      buttons: [
        {
          text: 'Nein',
          handler: () => { }
        },
        {
          text: 'Ok, verstehe',
          handler: () => {

            this.task.remove(task.id)
              .then(() => {
                console.info(`task ${task.title} removed`);
                this.task.persist();
                this.nav.setRoot(HomePage)
              })
              .catch((e) => {
                console.error(e);
              });

          }
        }
      ]
    });
    setTimeout(() => confirm.present());
  }
}


// WEBPACK FOOTER //
// ./src/components/tasks-detail/tasks-detail.ts